import { cn } from "@/lib/utils";

interface AnswerPillProps {
  label: string;
  selected: boolean;
  onClick: () => void;
}

export function AnswerPill({ label, selected, onClick }: AnswerPillProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selected}
      className={cn(
        "rounded-[10px] px-4 py-2 text-sm transition-colors",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-states-focused",
        selected
          ? "bg-text-primary text-white"
          : "bg-surfaces-z3 text-secondary hover:bg-surfaces-z4",
      )}
    >
      {label}
    </button>
  );
}
